import { render, staticRenderFns } from "./AppsAvailable.vue?vue&type=template&id=3f7f1f98"
import script from "./AppsAvailable.vue?vue&type=script&lang=js"
export * from "./AppsAvailable.vue?vue&type=script&lang=js"
import style0 from "./AppsAvailable.vue?vue&type=style&index=0&id=3f7f1f98&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports